/**
 * Container for LockApp component.
 */
import React, { ReactNode } from 'react'
import { connect } from 'react-redux'
import { Dispatch, AnyAction } from 'redux'

import { RootStoreState } from '../../root/index'
import * as apiActions from '../../api/actions'
import * as lockapp from '../reducer'
import { getConfiguration } from '../../configuration'
import { InAppPurchaseWebPrice, MediaItem, RedeemCode } from 'mytours-read-api-typescript'

export interface OwnProps {
	title: string
	description: string
	backgroundImage: MediaItem
	linkedId?: number
	linkedType?: RedeemCode.LinkedTypeEnum
	webPrice?: InAppPurchaseWebPrice
	openPayModalImmediately?: boolean
	/** Rendered under the gate's own actions — the bundles that also sell this content. */
	footer?: ReactNode
}

export interface Props extends OwnProps {
	lockApp?: lockapp.StoreState
}

export interface Actions {
	redeemCode: (couponCode: string, linkedId: number, linkedType: RedeemCode.LinkedTypeEnum, email?: string) => void
}

const mapStateToProps = (state: RootStoreState, ownProps: OwnProps): Props => {
	return {
		title: ownProps.title,
		description: ownProps.description,
		backgroundImage: ownProps.backgroundImage,
		lockApp: state.lockapp,
		linkedId: ownProps.linkedId,
		linkedType: ownProps.linkedType,
		webPrice: ownProps.webPrice,
	}
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): Actions => ({
	redeemCode: (couponCode: string, linkedId: number, linkedType: RedeemCode.LinkedTypeEnum, email?: string) => {
		const platform = getConfiguration().getPlatform()
		const deviceUUID = getConfiguration().getDeviceUUID()
		dispatch(
			apiActions.redeemCode.started({
				linkedId,
				linkedType,
				devicePlatform: platform,
				deviceUdid: deviceUUID,
				couponCode,
				email,
			}),
		)
	},
})

export default (Component: React.ComponentType<Props & Actions>) =>
	connect(mapStateToProps, mapDispatchToProps)(Component)
